import { PageLoading } from 'module/ui/components/atoms/loading';
import React, { Suspense } from 'react';
import { useLocation } from 'react-router-dom';
import { StyleSheetManager } from 'styled-components';
import styled from 'styled-components';

// Dynamic import of the federated component
const AgentBuilderApp = React.lazy(() =>
  import('agentBuilder/AgentBuilderApp').then((module) => ({
    default: module.AgentBuilderApp,
  })),
);
const AgentBuilderWrapper = styled.div<{ $isAgentBuilderPath: boolean }>`
  width: 100%;
  height: 100%;
`;

export const AgentBuilderRemote: React.FC = () => {
  const location = useLocation();

  // Check if current path is agent-builder to adjust margins
  const pathname = location.pathname;
  const agentBuilderSubPaths = [
    '/create',
    '/edit',
    '/livepreview',
    '/experts/',
    '/migration-agents/',
  ];
  const excludedAgentBuilderSubPaths = ['/migration-agents/create'];
  const isAgentBuilderPath =
    pathname.startsWith('/agent-builder') &&
    agentBuilderSubPaths.some((subPath) => pathname.includes(subPath)) &&
    !excludedAgentBuilderSubPaths.some((subPath) => pathname.includes(subPath));

  return (
    <Suspense fallback={<PageLoading />}>
      <StyleSheetManager target={document.head}>
        <AgentBuilderWrapper $isAgentBuilderPath={isAgentBuilderPath}>
          <AgentBuilderApp />
        </AgentBuilderWrapper>
      </StyleSheetManager>
    </Suspense>
  );
};
